import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, Output, ViewChild, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { SelectionMode } from '../../../model/common/selection-mode.enum';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  standalone: false,
})
export class TableComponent implements OnInit, OnChanges {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @Input() columnHeaders: string[] = [];
  @Input() displayedColumns: string[] = [];
  @Input() data: any[] = [];
  @Input() dataSource = new MatTableDataSource<any>();
  @Input() totalItems = 0;
  @Input() pageSize = 10;
  @Input() selectionMode: SelectionMode = SelectionMode.MULTIPLE;
  @Input() loading = false;
  @Input() backendPagination = true;
  @Output() pageChange = new EventEmitter<{ pageIndex: number; pageSize: number }>();
  @Output() selectedChange = new EventEmitter<any[]>();
  @Output() refresh = new EventEmitter<boolean>();

  selection!: SelectionModel<any>;
  SelectionMode = SelectionMode;

  ngOnInit(): void {
    const allowMulti = this.selectionMode === SelectionMode.MULTIPLE;
    this.selection = new SelectionModel<any>(allowMulti, []);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.selection) {
      this.selection.clear();
      if (!this.backendPagination) {
        this.dataSource.data = this.data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    }
  }

  get headerColumns(): string[] {
    return this.displayedColumns;
  }

  onPageChange(event: PageEvent): void {
    if (this.backendPagination) {
      this.pageChange.emit({ pageIndex: event.pageIndex, pageSize: event.pageSize });
    } else {
      this.pageChange.emit();
    }
  }

  onRowSelect(row: any): void {
    const isSingle = this.selectionMode === SelectionMode.SINGLE;

    if (isSingle) {
      if (this.selection.isSelected(row)) {
        this.selection.clear();
      } else {
        this.selection.clear();
        this.selection.select(row);
      }
    } else {
      this.selection.toggle(row);
    }

    this.selectedChange.emit(this.selection.selected);
  }

  isSelected(row: any): boolean {
    return this.selection.isSelected(row);
  }

  onRefresh(): void {
    this.refresh.emit(true);
  }
}
